"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _get = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");
var DefaultVideoStreamIndex_1 = require("./DefaultVideoStreamIndex");
var VideoStreamDescription_1 = require("./VideoStreamDescription");
/**
 * [[SimulcastTransceiverController]] implements [[VideoStreamIndex]] to facilitate video stream
 * subscription and includes query functions for stream id and attendee id.
 */
var SimulcastVideoStreamIndex = /*#__PURE__*/function (_DefaultVideoStreamIn) {
  _inherits(SimulcastVideoStreamIndex, _DefaultVideoStreamIn);
  function SimulcastVideoStreamIndex(logger) {
    var _this;
    _classCallCheck(this, SimulcastVideoStreamIndex);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulcastVideoStreamIndex).call(this, logger));
    _this.streamIdToBitrateKbpsMap = new Map();
    _this._localStreamInfos = [];
    _this._lastBitRateMsgTime = Date.now();
    return _this;
  }
  _createClass(SimulcastVideoStreamIndex, [{
    key: "localStreamDescriptions",
    value: function localStreamDescriptions() {
      var clonedDescriptions = [];
      this._localStreamInfos.forEach(function (desc) {
        clonedDescriptions.push(desc.clone());
      });
      return clonedDescriptions;
    }
  }, {
    key: "integrateUplinkPolicyDecision",
    value: function integrateUplinkPolicyDecision(encodingParams) {
      // Reuse local streams (that might already have stream IDs allocated) until
      // there are no more and then add as many new local streams as needed
      var hasStreamsToReuse = true;
      var localStreamIndex = 0;
      for (var i = 0; i < encodingParams.length; i++) {
        var targetMaxBitrateKbps = encodingParams[i].maxBitrate / 1000;
        var targetMaxFrameRate = encodingParams[i].maxFramerate;
        if (!hasStreamsToReuse || i === this._localStreamInfos.length) {
          hasStreamsToReuse = false;
          var newInfo = new VideoStreamDescription_1.default();
          newInfo.maxBitrateKbps = targetMaxBitrateKbps;
          newInfo.maxFrameRate = targetMaxFrameRate;
          newInfo.disabledByUplinkPolicy = targetMaxBitrateKbps === 0 ? true : false;
          if (targetMaxBitrateKbps !== 0) {
            newInfo.timeEnabled = Date.now();
          }
          this._localStreamInfos.push(newInfo);
          localStreamIndex++;
          continue;
        }
        if (this._localStreamInfos[localStreamIndex].maxBitrateKbps === 0 && targetMaxBitrateKbps > 0) {
          this._localStreamInfos[localStreamIndex].timeEnabled = Date.now();
        }
        this._localStreamInfos[localStreamIndex].maxBitrateKbps = targetMaxBitrateKbps;
        this._localStreamInfos[localStreamIndex].maxFrameRate = targetMaxFrameRate;
        this._localStreamInfos[localStreamIndex].disabledByUplinkPolicy = targetMaxBitrateKbps === 0 ? true : false;
        if (this._localStreamInfos[localStreamIndex].disabledByUplinkPolicy === true) {
          this._localStreamInfos[localStreamIndex].disabledByWebRTC = false;
        }
        localStreamIndex++;
      }
      if (hasStreamsToReuse) {
        // splice is zero-based, remove stream starting from localStreamIndex
        this._localStreamInfos.splice(localStreamIndex);
      }
    }
  }, {
    key: "integrateBitratesFrame",
    value: function integrateBitratesFrame(bitrateFrame) {
      _superPropGet(SimulcastVideoStreamIndex, "integrateBitratesFrame", this, 3)([bitrateFrame]);
      var stillSending = new Set();
      var existingSet = new Set(this.streamIdToBitrateKbpsMap.keys());
      var _iterator = _createForOfIteratorHelper(bitrateFrame.bitrates),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bitrateMsg = _step.value;
          stillSending.add(bitrateMsg.sourceStreamId);
          this.streamIdToBitrateKbpsMap.set(bitrateMsg.sourceStreamId, this.convertBpsToKbps(bitrateMsg.avgBitrateBps));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(existingSet),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var id = _step2.value;
          if (!stillSending.has(id)) {
            var avgBitrateBps = this.streamIdToBitrateKbpsMap.get(id);
            if (avgBitrateBps === SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE) {
              this.streamIdToBitrateKbpsMap.set(id, SimulcastVideoStreamIndex.RECENTLY_INACTIVE_STREAM_BITRATE);
            } else {
              this.streamIdToBitrateKbpsMap.set(id, SimulcastVideoStreamIndex.NOT_SENDING_STREAM_BITRATE);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      for (var i = 0; i < this._localStreamInfos.length; i++) {
        this._localStreamInfos[i].disabledByWebRTC = false;
        var streamId = this._localStreamInfos[i].streamId;
        if (this._localStreamInfos[i].disabledByUplinkPolicy) {
          continue;
        }
        if (this.streamIdToBitrateKbpsMap.has(streamId)) {
          var avgBitrateKbps = this.streamIdToBitrateKbpsMap.get(streamId);
          if (avgBitrateKbps === SimulcastVideoStreamIndex.NOT_SENDING_STREAM_BITRATE && this._lastBitRateMsgTime - this._localStreamInfos[i].timeEnabled > SimulcastVideoStreamIndex.BitratesMsgFrequencyMs) {
            this._localStreamInfos[i].disabledByWebRTC = true;
          }
        } else {
          // Do not flag as disabled if it was recently enabled
          if (this._lastBitRateMsgTime - this._localStreamInfos[i].timeEnabled > SimulcastVideoStreamIndex.BitratesMsgFrequencyMs) {
            this._localStreamInfos[i].disabledByWebRTC = true;
          }
        }
      }
      this._lastBitRateMsgTime = Date.now();
      this.logLocalStreamDescriptions();
    }
  }, {
    key: "logLocalStreamDescriptions",
    value: function logLocalStreamDescriptions() {
      var msg = '';
      var _iterator3 = _createForOfIteratorHelper(this._localStreamInfos),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var desc = _step3.value;
          msg += "streamId=".concat(desc.streamId, " maxBitrate=").concat(desc.maxBitrateKbps, " disabledByWebRTC=").concat(desc.disabledByWebRTC, " disabledByUplink=").concat(desc.disabledByUplinkPolicy, "\n");
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.logger.debug(function () {
        return msg;
      });
    }
  }, {
    key: "integrateIndexFrame",
    value: function integrateIndexFrame(indexFrame) {
      _superPropGet(SimulcastVideoStreamIndex, "integrateIndexFrame", this, 3)([indexFrame]);
      var newIndexStreamIdSet = new Set();
      var existingSet = new Set(this.streamIdToBitrateKbpsMap.keys());
      var _iterator4 = _createForOfIteratorHelper(this.currentIndex.sources),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var stream = _step4.value;
          if (stream.mediaType !== SignalingProtocol_js_1.SdkStreamMediaType.VIDEO) {
            continue;
          }
          newIndexStreamIdSet.add(stream.streamId);
          if (!this.streamIdToBitrateKbpsMap.has(stream.streamId)) {
            this.streamIdToBitrateKbpsMap.set(stream.streamId, SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var _iterator5 = _createForOfIteratorHelper(existingSet),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var id = _step5.value;
          if (!newIndexStreamIdSet.has(id)) {
            this.streamIdToBitrateKbpsMap.delete(id);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "integrateSubscribeAckFrame",
    value: function integrateSubscribeAckFrame(subscribeAck) {
      _superPropGet(SimulcastVideoStreamIndex, "integrateSubscribeAckFrame", this, 3)([subscribeAck]);
      if (!subscribeAck.allocations || subscribeAck.allocations === undefined) {
        return;
      }
      var localStreamStartIndex = 0;
      var _iterator6 = _createForOfIteratorHelper(subscribeAck.allocations),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var allocation = _step6.value;
          // track label is what we offered to the server
          if (this._localStreamInfos.length < localStreamStartIndex + 1) {
            this.logger.info('simulcast: allocation has more than number of local streams');
            break;
          }
          this._localStreamInfos[localStreamStartIndex].groupId = allocation.groupId;
          this._localStreamInfos[localStreamStartIndex].streamId = allocation.streamId;
          if (!this.streamIdToBitrateKbpsMap.has(allocation.streamId)) {
            this.streamIdToBitrateKbpsMap.set(allocation.streamId, SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE);
          }
          localStreamStartIndex++;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }]);
  return SimulcastVideoStreamIndex;
}(DefaultVideoStreamIndex_1.default);
exports.default = SimulcastVideoStreamIndex;
// First time when the bitrate of a stream id is missing from bitrate message, mark it as UNSEEN
SimulcastVideoStreamIndex.UNSEEN_STREAM_BITRATE = -2;
// Second time when the bitrate is missing, mark it as recently inactive
SimulcastVideoStreamIndex.RECENTLY_INACTIVE_STREAM_BITRATE = -1;
// Third time when bitrate is missing, mark it as not sending
SimulcastVideoStreamIndex.NOT_SENDING_STREAM_BITRATE = 0;
SimulcastVideoStreamIndex.BitratesMsgFrequencyMs = 4000;